module.exports = __webpack_public_path__ + "static/media/json.6494e47d.png";